<script setup>
  import { Splide, SplideSlide } from '@splidejs/vue-splide';

  const { items, slide, narrowCards } = defineProps({ items: Array, slide: Object, narrowCards: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="slider-container" :class="{ narrowCards }">
    <Splide
      :options="{
        type: 'slide',
        drag: 'slide',
        speed: 500.0,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        arrows: false,
        gap: '24px',
        breakpoints: {
          768: {
            gap: '12px',
          },
          480: {
            gap: '4px',
          },
        },
      }"
    >
      <slot />
      <SplideSlide v-for="item in items" :key="item.id"><component :is="slide" :item="item" /></SplideSlide>
    </Splide>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .slider-container {
    .splide {
      display: flex;
      flex-direction: column;
    }

    :deep(.splide__list) {
      display: flex;
    }

    :deep(.splide__sr) {
      display: none !important;
    }

    :deep(.splide__pagination) {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      gap: px(8);
      margin-top: px(8);

      @include break-min-small {
        display: none;
      }

      .splide__pagination__page {
        background-color: $white-20;
        width: px(6);
        height: px(6);

        border-radius: 100%;

        @include hitbox(px(4));
        cursor: pointer;

        @include fade('background-color', 0.29s);

        @include hover {
          background: $red;
          @include fade('background-color', 0.04s);
        }

        &.is-active {
          background-color: $white;
        }
      }
    }

    @include break-small {
      &:not(.narrowCards) {
        :deep(.splide__list) {
          > li {
            flex-shrink: 0;
            width: 100%;
          }
        }
      }
    }

    @include break-phone {
      :deep(.splide__list) {
        > li {
          flex-shrink: 0;
          width: 100%;
        }
      }
    }
  }
</style>
